export default "__VITE_ASSET__Bbww6MrL__"